import { globalModel } from "../../global/GlobalModel";
import type { InfluencerCard } from "./LobbyType";

const ID8 = /^\d{8}$/;

function sortBySpaceName(cards: InfluencerCard[]): InfluencerCard[] {
  return [...cards].sort((a, b) =>
    a.name.localeCompare(b.name, "zh-Hans", { sensitivity: "base" })
  );
}

/** 头像下拉「我的订单」在无 URL 时使用：与 Lobby 列表首卡一致 */
export function syncOrdersFallbackFromRelatedSpaceCards(
  cards: InfluencerCard[]
) {
  if (cards.length === 0) {
    globalModel.setOrdersMenuFallbackSpaceId(null);
    return;
  }
  const sorted = sortBySpaceName(cards);
  const sid = sorted[0]?.targetSpaceId?.trim() ?? "";
  globalModel.setOrdersMenuFallbackSpaceId(ID8.test(sid) ? sid : null);
}
